import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, getAdminToken, setAdminToken, clearAdminToken } from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);   // null = checking, false = logged out
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (!getAdminToken()) { setAdmin(false); setLoading(false); return; }
      try {
        const r = await adminApi.get("/admin/me");
        setAdmin(r.data);
      } catch (_) {
        clearAdminToken();
        setAdmin(false);
      } finally { setLoading(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/admin/auth/login", { email, password });
    setAdminToken(r.data.token);
    setAdmin(r.data.user);
    return r.data.user;
  };

  const logout = () => { clearAdminToken(); setAdmin(false); };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
